import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function CGU() {
  return (
    <main className="min-h-screen bg-white text-gray-900">
      <NavBar />

      <section className="px-6 pt-10 pb-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Conditions Générales d'Utilisation</h1>
          <p className="mt-3 text-sm text-gray-500">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-10 text-[15px] leading-7 text-gray-800">

          <p>
            Les présentes conditions générales d'utilisation (ci-après « CGU ») ont pour objet de définir les
            modalités et conditions d'accès et d'utilisation du site internet <span className="font-medium">noxzi.fr</span>{" "}
            (ci-après « le Site ») et des services qui y sont proposés par la société NOXZI, ainsi que les droits
            et obligations de toute personne y accédant (ci-après « l'Utilisateur »).
          </p>
          <p>
            Tout accès au Site implique l'acceptation pleine et entière des présentes CGU. Si l'Utilisateur n'accepte
            pas ces conditions, il lui est demandé de ne pas utiliser le Site.
          </p>

          {/* Art. 1 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 1 — Éditeur et hébergeur</h2>
            <p>Le Site est édité par :</p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Société :</span> NOXZI, SASU au capital de 100,00 €</li>
              <li><span className="font-medium">Siège social :</span> 792 Chemin de Charrière Neuve, 73000 Chambéry, France</li>
              <li><span className="font-medium">RCS :</span> Chambéry — SIREN 990 027 377</li>
              <li><span className="font-medium">Directeur de la publication :</span> Lionel FAURE</li>
              <li><span className="font-medium">Téléphone :</span> +33 (0)6 03 59 99 52</li>
              <li><span className="font-medium">E-mail :</span>{" "}
                <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>
              </li>
            </ul>
            <p className="mt-4">Le Site est hébergé par :</p>
            <ul className="mt-3 space-y-1 list-none pl-0">
              <li><span className="font-medium">Société :</span> LWS – Ligne Web Services</li>
              <li><span className="font-medium">Siège social :</span> 4 rue Galvani, 75017 Paris, France</li>
              <li><span className="font-medium">Téléphone :</span> +33 1 77 62 30 03</li>
            </ul>
            <p className="mt-3">
              Pour toute information complémentaire, veuillez consulter nos{" "}
              <Link to="/mentions-legales" className="underline">Mentions légales</Link>.
            </p>
          </section>

          {/* Art. 2 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 2 — Accès au site</h2>
            <p>
              Le Site est accessible gratuitement à tout Utilisateur disposant d'un accès à Internet. Tous les coûts
              liés à cet accès (matériel informatique, logiciels, abonnement Internet, etc.) sont à la charge
              exclusive de l'Utilisateur.
            </p>
            <p className="mt-3">
              NOXZI se réserve le droit, sans préavis ni indemnité, de fermer temporairement ou définitivement
              l'accès à tout ou partie du Site, notamment pour des opérations de maintenance, de mise à jour, ou
              pour toute autre raison technique ou commerciale. La responsabilité de NOXZI ne saurait être engagée
              en cas d'indisponibilité du Site, quelle qu'en soit la cause.
            </p>
            <p className="mt-3">
              L'Utilisateur s'engage à accéder au Site en utilisant un matériel récent, ne contenant pas de virus
              et avec un navigateur à jour.
            </p>
          </section>

          {/* Art. 3 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 3 — Objet du site et services</h2>
            <p>
              Le Site a pour objet de présenter les activités et services proposés par NOXZI, notamment en matière
              de{" "}
              <span className="font-medium">[décrire ici votre activité : conseil, développement, design, etc.]</span>,
              et de permettre aux Utilisateurs d'entrer en contact avec la société.
            </p>
            <p className="mt-3">
              NOXZI se réserve le droit de modifier, compléter ou supprimer, à tout moment et sans préavis, tout ou
              partie des services et contenus du Site.
            </p>
          </section>

          {/* Art. 4 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 4 — Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments du Site (textes, images, photographies, graphismes, logos, vidéos, sons,
              structure, base de données, code source, etc.) est la propriété exclusive de NOXZI ou de ses
              partenaires, et est protégé par les dispositions du Code de la propriété intellectuelle, notamment
              les articles L. 111-1 et suivants (droit d'auteur) et L. 713-1 et suivants (droit des marques).
            </p>
            <p className="mt-3">
              Toute reproduction, représentation, diffusion, commercialisation ou modification, totale ou partielle,
              de ces éléments sans l'autorisation expresse et préalable de NOXZI est strictement interdite et
              constituerait une contrefaçon sanctionnée par les articles L. 335-2 et suivants du Code de la
              propriété intellectuelle.
            </p>
            <p className="mt-3">
              L'Utilisateur est autorisé à visualiser et imprimer les contenus du Site pour un usage strictement
              personnel, privé et non commercial. Toute autre utilisation est soumise à autorisation préalable et
              écrite de NOXZI.
            </p>
          </section>

          {/* Art. 5 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 5 — Responsabilité de l'Utilisateur</h2>
            <p>
              L'Utilisateur est seul responsable de l'usage qu'il fait du Site et de ses contenus. Il s'engage à :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Ne pas utiliser le Site à des fins illicites, frauduleuses ou portant atteinte aux droits de tiers ;</li>
              <li>Ne pas diffuser de contenus illégaux, diffamatoires, injurieux, ou portant atteinte à la vie privée ;</li>
              <li>Ne pas tenter de perturber ou d'altérer le bon fonctionnement du Site (attaques informatiques, virus, spam, etc.) ;</li>
              <li>Respecter les droits de propriété intellectuelle de NOXZI et des tiers ;</li>
              <li>Fournir des informations exactes et à jour lorsqu'il complète un formulaire sur le Site.</li>
            </ul>
            <p className="mt-3">
              En cas de manquement à ces obligations, NOXZI se réserve le droit de prendre toute mesure appropriée,
              y compris le blocage de l'accès au Site, et d'engager toute action en responsabilité civile et/ou pénale.
            </p>
          </section>

          {/* Art. 6 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 6 — Responsabilité de NOXZI</h2>
            <p>
              Les informations publiées sur le Site sont fournies à titre purement indicatif. NOXZI s'efforce de
              maintenir ces informations à jour mais ne garantit pas leur exactitude, exhaustivité ou actualité.
            </p>
            <p className="mt-3">
              NOXZI ne saurait être tenue responsable :
            </p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li>Des dommages directs ou indirects résultant de l'utilisation ou de l'impossibilité d'utiliser le Site ;</li>
              <li>Des erreurs ou omissions dans les contenus publiés ;</li>
              <li>De la perte de données ou d'opportunités commerciales ;</li>
              <li>Des dommages causés au matériel de l'Utilisateur lors de l'accès au Site ;</li>
              <li>Des actes ou omissions de tiers (prestataires, hébergeur, etc.).</li>
            </ul>
            <p className="mt-3">
              La responsabilité de NOXZI ne pourra pas davantage être engagée en cas de force majeure au sens de
              l'article 1218 du Code civil.
            </p>
          </section>

          {/* Art. 7 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 7 — Liens hypertextes</h2>
            <p>
              Le Site peut contenir des liens vers des sites tiers. Ces liens sont fournis à titre indicatif.
              NOXZI n'exerce aucun contrôle sur ces sites et ne saurait être tenue responsable de leur contenu,
              de leurs pratiques en matière de données personnelles ou de leur accessibilité.
            </p>
            <p className="mt-3">
              La mise en place de liens hypertextes pointant vers le Site est autorisée sous réserve que ces
              liens ne portent pas atteinte à l'image de NOXZI, n'induisent pas de confusion sur l'origine des
              contenus et ne constituent pas un acte de concurrence déloyale. Tout lien de type cadre (frame)
              est expressément interdit sauf accord écrit préalable.
            </p>
          </section>

          {/* Art. 8 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 8 — Cookies</h2>
            <p>
              Lors de la consultation du Site, des cookies peuvent être déposés automatiquement sur le terminal
              de l'Utilisateur. Un cookie est un fichier texte de petite taille enregistré sur l'appareil de
              l'Utilisateur lors de la visite d'un site internet.
            </p>
            <p className="mt-3">Les cookies utilisés sur le Site peuvent avoir les finalités suivantes :</p>
            <ul className="mt-2 ml-5 list-disc space-y-1">
              <li><span className="font-medium">Cookies techniques :</span> nécessaires au bon fonctionnement du Site (session, préférences de navigation) ;</li>
              <li><span className="font-medium">Cookies analytiques :</span> permettant de mesurer l'audience du Site et d'en améliorer les performances (ex. : Google Analytics ou équivalent) ;</li>
              <li><span className="font-medium">Cookies de personnalisation :</span> permettant d'adapter l'affichage du Site aux préférences de l'Utilisateur.</li>
            </ul>
            <p className="mt-3">
              Conformément aux recommandations de la CNIL, les cookies non essentiels ne sont déposés qu'avec le
              consentement préalable de l'Utilisateur, recueilli via un bandeau de gestion des cookies lors de
              la première visite.
            </p>
            <p className="mt-3">
              L'Utilisateur peut à tout moment modifier ses préférences en matière de cookies via les paramètres
              de son navigateur ou via l'outil de gestion des cookies disponible sur le Site. Le refus de certains
              cookies peut toutefois affecter le fonctionnement de certaines fonctionnalités du Site.
            </p>
          </section>

          {/* Art. 9 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 9 — Données personnelles</h2>
            <p>
              NOXZI traite les données personnelles des Utilisateurs dans le strict respect du Règlement (UE)
              2016/679 (RGPD) et de la loi n° 78-17 du 6 janvier 1978 modifiée relative à l'informatique, aux
              fichiers et aux libertés.
            </p>
            <p className="mt-3">
              Les données collectées via les formulaires du Site sont utilisées exclusivement pour répondre aux
              demandes des Utilisateurs, assurer le suivi de la relation commerciale, et, le cas échéant, avec
              leur consentement, envoyer des communications marketing.
            </p>
            <p className="mt-3">
              NOXZI s'engage à ne jamais vendre, louer ou céder les données personnelles à des tiers sans le
              consentement préalable et exprès de l'Utilisateur, sauf obligation légale.
            </p>
            <p className="mt-3">
              Pour plus d'informations et pour exercer vos droits (accès, rectification, effacement, opposition,
              portabilité, limitation), veuillez consulter notre{" "}
              <Link to="/politique-de-confidentialite" className="underline">Politique de confidentialité</Link>{" "}
              ou contacter NOXZI à l'adresse :{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>.
            </p>
          </section>

          {/* Art. 10 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 10 — Sécurité</h2>
            <p>
              NOXZI met en œuvre les mesures techniques et organisationnelles appropriées pour assurer la sécurité
              du Site et des données transmises par les Utilisateurs, notamment contre l'accès non autorisé,
              la modification, la divulgation ou la destruction de données.
            </p>
            <p className="mt-3">
              Toutefois, aucun système de transmission ou de stockage de données sur Internet ne peut être garanti
              comme étant totalement sécurisé. NOXZI ne peut donc garantir la sécurité absolue des informations
              transmises via le Site.
            </p>
            <p className="mt-3">
              En cas de détection d'une faille de sécurité susceptible d'affecter les données personnelles,
              NOXZI s'engage à en informer les personnes concernées dans les délais prévus par la réglementation.
            </p>
          </section>

          {/* Art. 11 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 11 — Modification des CGU</h2>
            <p>
              NOXZI se réserve le droit de modifier les présentes CGU à tout moment, notamment pour se conformer
              à toute évolution légale, réglementaire, jurisprudentielle ou technique. Les CGU applicables sont
              celles en vigueur au moment de la connexion de l'Utilisateur.
            </p>
            <p className="mt-3">
              En cas de modification substantielle, NOXZI s'engage à en informer les Utilisateurs par tout moyen
              approprié. La poursuite de l'utilisation du Site après modification vaut acceptation des nouvelles CGU.
            </p>
          </section>

          {/* Art. 12 */}
          <section>
            <h2 className="text-xl font-semibold mb-3 text-black">Article 12 — Droit applicable et règlement des litiges</h2>
            <p>
              Les présentes CGU sont soumises au droit français, à l'exclusion de tout autre droit.
            </p>
            <p className="mt-3">
              En cas de litige relatif à l'interprétation ou à l'exécution des présentes CGU, les parties
              s'engagent à rechercher une solution amiable dans un délai de 30 jours suivant la notification
              du différend par l'une des parties.
            </p>
            <p className="mt-3">
              À défaut d'accord amiable, le litige sera porté devant les tribunaux compétents du ressort de
              Chambéry, sauf règles impératives contraires applicables notamment en matière de droit de la
              consommation.
            </p>
            <p className="mt-3">
              Conformément aux articles L. 611-1 et suivants du Code de la consommation, tout consommateur a le
              droit de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable
              du litige qui l'oppose à un professionnel. Les coordonnées du médiateur compétent seront
              communiquées sur demande adressée à{" "}
              <a href="mailto:contact@noxzi.fr" className="underline">contact@noxzi.fr</a>.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </main>
  );
}